/**
 * WTS `ErrorBaseCode` that `DELETE /Events` answers with when at least one of the events is
 * generated from a confirmed request. The endpoint is atomic: nothing is deleted and the whole
 * batch is rejected until the very same request is repeated with `removeConfirmation=true`.
 *
 * The answer arrives as HTTP 400 (`FeatureErrorsFilter` rewrites the status whenever `Errors` is
 * not empty), so the status alone is not a marker — other `DELETE /Events` errors (e.g. missing
 * department rights) answer with 400 as well, but with `ResultId: 0`.
 */
export const EVENT_HAS_CONFIRMED_REQUEST_RESULT_ID = 532;
export const isConfirmedRequestAbsenceError = (error) => (error?.response?.data?.ResultId
    === EVENT_HAS_CONFIRMED_REQUEST_RESULT_ID);
